<template>
    <div class="tabbed" :class="containerClasses">
        <div class="tabs" :class="classes">
            <ul>
                <li
                    v-for="(tab, idx) in tabs"
                    :class="{ active: tab.isActive }"
                    :key="tab.name"
                    ref="tabs"
                    :style="selectorStyles(tab, idx)"
                    @click="selectTab(tab)"
                >
                    <button-slot :slot="tab.$slots.button"></button-slot>
                </li>
            </ul>
            <button
                type="button"
                class="tab-nav tab-prev"
                :disabled="!canNavPrev"
                @click="previousTab"
            >
                <svg-icon id="chevronLeft"></svg-icon>
            </button>
            <button
                type="button"
                class="tab-nav tab-next"
                :disabled="!canNavNext"
                @click="nextTab"
            >
                <svg-icon id="chevronRight"></svg-icon>
            </button>
        </div>
        <div class="content-panes">
            <slot ref="tabContent"></slot>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        ButtonSlot: {
            functional: true,
            render: (h, ctx) => ctx.props.slot,
        },
    },
    props: {
        disabled: {
            type: Boolean,
            required: false,
        },
        containerClasses: {
            type: String,
            required: false,
        },
        classes: {
            type: String,
            required: false,
        },
        scrollTabs: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            children: [],
        };
    },
    computed: {
        activeIndex() {
            for (let x = 0; x < this.tabs.length; x++) {
                if (this.tabs[x].isActive) {
                    return x;
                }
            }

            return 0;
        },
        canNavPrev() {
            if (this.tabs.length > 1) {
                return !this.tabs[0].isActive;
            }

            return false;
        },
        canNavNext() {
            if (this.tabs.length > 1) {
                return !this.tabs[this.tabs.length - 1].isActive;
            }

            return false;
        },
        tabs() {
            let tabs = [];

            for (let child of this.children) {
                if (child.$options._componentTag == "tab") {
                    tabs.push(child);
                }
            }

            return tabs;
        },
    },
    created() {
        this.children = this.$children;
    },
    methods: {
        selectTab(selectedTab) {
            if (this.disabled) {
                return;
            }
            this.$eventBus.$emit("tabChange", selectedTab);
            this.$emit("change", selectedTab);
            this.tabs.forEach((tab) => {
                tab.isActive = tab.name === selectedTab.name;
            });
        },

        selectorStyles(tab, idx) {
            let styles = {};

            if (this.scrollTabs && idx == 0) {
                styles["margin-left"] = this.activeIndex * -100 + "%";
            }

            return styles;
        },

        previousTab() {
            if (this.canNavPrev) {
                this.selectTab(this.tabs[this.activeIndex - 1]);
            }
        },

        nextTab() {
            if (this.canNavNext) {
                this.selectTab(this.tabs[this.activeIndex + 1]);
            }
        },

        moveIndicatorToActive() {
            const tab = this.$refs.tabs.find(
                (el) =>
                    typeof el.classList[0] !== "undefined" &&
                    el.classList[0] === "active"
            );
            if (tab) {
                const left = Math.round(tab.offsetWidth / 2) + tab.offsetLeft;
                if (this.$refs.indicator) {
                    this.$refs.indicator.style.left = `${left}px`;
                }
            }
        },
    },
};
</script>
